export default __webpack_public_path__ + "static/media/07_DAIF_SUSTAINABILITY_03.28f81ef6.mp4";